<form (ngSubmit)="createQuestion()" [formGroup]="form">
  <div fxLayout="row" fxLayoutAlign="start center" mat-dialog-title>
    <h2 class="headline m-0" fxFlex="auto">
      {{'NEW_QUESTIONS' | translate}}
    </h2>
    <button class="text-secondary" mat-dialog-close mat-icon-button type="button">
      <mat-icon [icIcon]="icClose"></mat-icon>
    </button>
  </div>

  <mat-divider class="-mx-6 text-border"></mat-divider>

  <mat-dialog-content fxLayout="column">
    <mat-form-field class="flex-auto mt-4" appearance="outline">
      <mat-label>{{'QUESTION' | translate}}</mat-label>
      <textarea matInput formControlName="question" placeholder="Enter your question here"></textarea>
    </mat-form-field>

    <mat-form-field class="flex-auto" appearance="outline">
      <mat-label>{{'ORDER' | translate}}</mat-label>
      <mat-select formControlName="order">
        <mat-option value="0">0</mat-option>
        <mat-option value="1">1</mat-option>
        <mat-option value="2">2</mat-option>
        <mat-option value="3">3</mat-option>
        <mat-option value="4">4</mat-option>
        <mat-option value="5">5</mat-option>
        <mat-option value="6">6</mat-option>
        <mat-option value="7">7</mat-option>
        <mat-option value="8">8</mat-option>
        <mat-option value="9">9</mat-option>
      </mat-select>
      <mat-icon [icIcon]="icFence" matPrefix></mat-icon>
    </mat-form-field>

    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>{{'GROUP' | translate}}</mat-label>
      <input type="text" matInput formControlName="groupName" [matAutocomplete]="auto">
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="getTitle.bind(this)">
        <mat-option *ngFor="let option of filteredOptions | async" [value]="option.qcat_id">
          {{option.qcatname}}
        </mat-option>
      </mat-autocomplete>
      <mat-icon [icIcon]="icGroup" matPrefix></mat-icon>
      <mat-hint>{{'OR_TYPE_TO_CREATE_NEW_GROUP' | translate}}</mat-hint>
    </mat-form-field>

    <div class="flex-auto question-type-radio-button mt-4" fxLayout="column" fxLayoutAlign="start start">
      <mat-label class="mb-2 question-field-heading">{{'QUESTION_TYPE' | translate}}</mat-label>
      <div class="flex-auto mb-4 w-full" fxLayout="row" fxLayoutAlign="start start">
        <mat-radio-group class="w-full" color="primary" fxLayout="column" fxLayoutAlign="start start"
          formControlName="questionType" (change)="getQuetionType($event.value)">
          <mat-radio-button class="mr-4 mb-4" value="0">{{'TEXT_DEFAULT_TYPE' | translate}}
          </mat-radio-button>
          <mat-radio-button class="mr-4 mb-4" value="1">{{'YES_NO' | translate}}</mat-radio-button>
          <mat-radio-button class="mr-4 mb-4" value="2">{{'YES_NO_NOT_APPLICABLE' | translate}}</mat-radio-button>
          <mat-radio-button class="mr-4 mb-4" value="3">{{'LESS_THAN_1_10' | translate}}</mat-radio-button>
          <mat-radio-button class="mr-4 mb-4" value="4">{{'1_TO_5' | translate}}</mat-radio-button>
          <mat-radio-button class="mr-4 mb-4" value="5">{{'NONE_BASIC_INTERMIDIATE_ADVANCED' | translate}}</mat-radio-button>
          <mat-radio-button class="mr-4 mb-4" value="6">{{'NO_SOME_MODERATE_EXTENSIVE_EXPERIENCE' | translate}}</mat-radio-button>
          <mat-radio-button class="mr-4 mb-4" value="7">{{'NONE_6_OVER_A_YEAR' | translate}}</mat-radio-button>
          <mat-radio-button class="mr-4 mb-4" value="8">{{'1_TO_5_TO_10_MORE_THAN_10' | translate}}</mat-radio-button>
          <mat-radio-button class="mr-4 w-full" value="9">
            <div class="flex-auto mb-4 w-full custom-check-list" fxLayout="column" fxLayoutAlign="start start">
              <mat-form-field class="example-chip-list w-full" appearance="outline" (click)="$event.stopPropagation()">
                <mat-label>{{'CUSTOM_CHECK_LIST' | translate}}</mat-label>
                <mat-chip-list #chipList aria-label="Fruit selection">
                  <mat-chip *ngFor="let fruit of fruits1" [selectable]="selectable1" [removable]="removable1"
                    (removed)="remove1(fruit)">
                    {{fruit}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip>
                  <input placeholder="Type here..." #fruitInput1 formControlName="checkList" [matAutocomplete]="auto1"
                    [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes1"
                    (matChipInputTokenEnd)="add1($event)">
                </mat-chip-list>
                <mat-autocomplete #auto1="matAutocomplete" (optionSelected)="selected1($event)">
                  <mat-option *ngFor="let fruit of filteredFruits1 | async" [value]="fruit">
                    {{fruit}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-checkbox color="primary" class="example-margin">{{'SAVE_ANSWER_AS_A_SKILL_TAGS' | translate}}</mat-checkbox>
            </div>
          </mat-radio-button>
          <mat-radio-button class="mr-4 w-full" value="10">
            <div class="flex-auto mb-4 w-full custom-radio" fxLayout="column" fxLayoutAlign="start start">
              <div class="flex-auto w-full" fxLayout="row" fxLayoutAlign="start center">
                <mat-form-field class="example-chip-list w-full" appearance="outline"
                  (click)="$event.stopPropagation()">
                  <mat-label>{{'CUSTOM_RADIO' | translate}} </mat-label>
                  <mat-chip-list #chipList2 aria-label="Fruit selection">
                    <mat-chip *ngFor="let fruit of fruits2" [selectable]="selectable2" [removable]="removable2"
                      (removed)="remove2(fruit)">
                      {{fruit}}
                      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                    </mat-chip>
                    <input placeholder="Type here..." #fruitInput2 formControlName="customRadio"
                      [matAutocomplete]="auto2" [matChipInputFor]="chipList2"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes2" (matChipInputTokenEnd)="add2($event)">
                  </mat-chip-list>
                  <mat-autocomplete #auto2="matAutocomplete" (optionSelected)="selected2($event)">
                    <mat-option *ngFor="let fruit of filteredFruits2 | async" [value]="fruit">
                      {{fruit}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <mat-checkbox color="primary" class="example-margin ">{{'SAVE_ANSWER_AS_A_SKILL_TAGS' | translate}}</mat-checkbox>
            </div>
          </mat-radio-button>
          <mat-radio-button class="mr-4 w-full" value="11">
            <div class="flex-auto mb-4 w-full custom-select" fxLayout="column" fxLayoutAlign="start start">
              <div class="flex-auto  w-full" fxLayout="row" fxLayoutAlign="start center">
                <mat-form-field class="example-chip-list w-full" appearance="outline">
                  <mat-label>{{'CUSTOM_SELECT' | translate}} </mat-label>
                  <mat-chip-list #chipList3 aria-label="Fruit selection">
                    <mat-chip *ngFor="let fruit of fruits3" [selectable]="selectable3" [removable]="removable3"
                      (removed)="remove3(fruit)">
                      {{fruit}}
                      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                    </mat-chip>
                    <input placeholder="Type here..." #fruitInput3 formControlName="customSelect"
                      [matAutocomplete]="auto3" [matChipInputFor]="chipList3"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes3" (matChipInputTokenEnd)="add3($event)">
                  </mat-chip-list>
                  <mat-autocomplete #auto3="matAutocomplete" (optionSelected)="selected3($event)">
                    <mat-option *ngFor="let fruit of filteredFruits3 | async" [value]="fruit">
                      {{fruit}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <mat-checkbox color="primary" class="example-margin ">{{'SAVE_ANSWER_AS_A_SKILL_TAGS' | translate}}</mat-checkbox>
            </div>
          </mat-radio-button>
          <mat-radio-button class="mr-4 w-full" value="12">
            <div class="flex-auto mb-4 w-full custom-multi-select" fxLayout="column" fxLayoutAlign="start start">
              <div class="flex-auto w-full" fxLayout="row" fxLayoutAlign="start center">
                <mat-form-field class="example-chip-list w-full" appearance="outline">
                  <mat-label>{{'CUSTOM_MULTI_SELECT' | translate}}</mat-label>
                  <mat-chip-list #chipList4 aria-label="Fruit selection">
                    <mat-chip *ngFor="let fruit of fruits4" [selectable]="selectable4" [removable]="removable4"
                      (removed)="remove4(fruit)">
                      {{fruit}}
                      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                    </mat-chip>
                    <input placeholder="Type here..." #fruitInput4 formControlName="customMultiSelect"
                      [matAutocomplete]="auto4" [matChipInputFor]="chipList4"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes4" (matChipInputTokenEnd)="add4($event)">
                  </mat-chip-list>
                  <mat-autocomplete #auto4="matAutocomplete" (optionSelected)="selected4($event)">
                    <mat-option *ngFor="let fruit of filteredFruits4 | async" [value]="fruit">
                      {{fruit}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <mat-checkbox color="primary" class="example-margin ">{{'SAVE_ANSWER_AS_A_SKILL_TAGS' | translate}}</mat-checkbox>
            </div>
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <div class="flex-auto mb-4 mt-4" fxLayout="row" fxLayoutAlign="start center">
      <p class="mr-4"> {{'MAKE_ANSWERING_REQUIRED' | translate}} </p>
      <mat-radio-group color="primary" formControlName="answerRequired">
        <mat-radio-button class="mr-4" value="1">{{'YES' | translate}}</mat-radio-button>
        <mat-radio-button value="0">{{'NO' | translate}}</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="flex flex-col sm:flex-row field-hints">
      <mat-form-field class="flex-auto" appearance="outline">
        <mat-label>{{'KNOCK_OUT_ANSWER' | translate}}</mat-label>
        <mat-select formControlName="knockOutAnswer">
          <mat-option *ngFor="let option of knockOutData" [value]="option.value">{{option.item}}</mat-option>
        </mat-select>

        <mat-icon [icIcon]="icQuestionAnswer" class="mr-3" matPrefix></mat-icon>
        <mat-hint>{{'SELECT_ANSWER_MARK_AS_NOT_QUALIFIED_AND_DISPOSITION' | translate}}</mat-hint>
      </mat-form-field>

      <mat-form-field class="sm:ml-6 flex-auto" appearance="outline">
        <mat-label>{{'DISPOSITION_FLOW' | translate}}</mat-label>
        <mat-select formControlName="dispositionFlow">
          <mat-option *ngFor="let option of recruitFlowData" [value]="option.recruitFlowID">{{option.recruitFlowName}}
          </mat-option>
        </mat-select>

        <mat-icon [icIcon]="icFence" class="mr-3" matPrefix></mat-icon>
        <mat-hint class="disposition-hint">{{'MOVED_NOT_QUALIFIED_APPLICANTS_TO' | translate}}</mat-hint>
      </mat-form-field>
    </div>

    <mat-label class="mb-1 mt-4 question-field-heading ">{{'DISPLAYING_TYPE' | translate}}</mat-label>
    <mat-hint>(<span class="displaying-type-hint">{{'PUBLIC' | translate}}:</span> {{'WILL_BE_VISIBLE_TO_ALL_APPLICANTS' | translate}} <span
        class="displaying-type-hint">{{'INTERNAL' | translate}}:</span> {{'WILL_BE_VISIBLE_IN_INTRANET_OR_INSIDE_THE_SYSTEM' | translate}})</mat-hint>
    <mat-radio-group color="primary" formControlName="displayType" class="flex-auto pb-6 mt-1" [(ngModel)]="isPublic">
      <mat-radio-button class="mr-4" value="1">{{'PUBLIC' | translate}}</mat-radio-button>
      <mat-radio-button value="0">{{'INTERNAL' | translate}}</mat-radio-button>
    </mat-radio-group>

  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close type="button" (keydown.enter)="$event.preventDefault()">{{'CANCEL' | translate}}</button>
    <button color="primary" mat-button type="submit" (keydown.enter)="$event.preventDefault()">{{'ADD_QUESTIONS' | translate}}</button>

  </mat-dialog-actions>
</form>

<mat-menu #settingsMenu="matMenu" xPosition="before" yPosition="below">
  <button mat-menu-item>
    <mat-icon [icIcon]="icPrint"></mat-icon>
    <span>{{'PRINT' | translate}}</span>
  </button>

  <button mat-menu-item>
    <mat-icon [icIcon]="icDownload"></mat-icon>
    <span>{{'EXPORT'| translate}}</span>
  </button>

  <button mat-menu-item>
    <mat-icon [icIcon]="icDelete"></mat-icon>
    <span>{{'DELETE' | translate}}</span>
  </button>
</mat-menu>